// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"filter-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3.56348 18.4913L7.29802 22.2259L17.5542 11.9696L13.8197 8.23511L3.56348 18.4913Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M20.9728 8.55095L17.2383 4.81641L13.8195 8.23514L17.5541 11.9697L20.9728 8.55095Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.2384 4.81641L20.973 8.55095M17.2384 4.81641L3.56348 18.4914L7.29802 22.2259L20.973 8.55095M17.2384 4.81641L13.8197 8.23514L17.5542 11.9697L20.973 8.55095","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M7.75 3.5L8.16543 4.33457L9 4.75L8.16543 5.16543L7.75 6L7.33457 5.16543L6.5 4.75L7.33457 4.33457L7.75 3.5Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M21.625 3L21.6665 3.08346L21.75 3.125L21.6665 3.16654L21.625 3.25L21.5835 3.16654L21.5 3.125L21.5835 3.08346L21.625 3Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const Filter2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'filter-2',
    ref,
    icon: element,
  },
));

Filter2Icon.displayName = 'Filter2Icon';

export default Filter2Icon;
